<template src="./TransferOfValues.html" />

<script>
import mixins from "@/Mixins.js";
export default {
  mixins: [mixins],
  data() {
    return {
      bearer: null,
      transferValue: "",
      popupTransferSuccess: false,
      searchTimeout: null,

      cpfFrom: null,
      patientsFrom: [],
      fromSelected: null,
      searchFrom: "",
      updatedFrom: {
        name: null,
        cpf: null,
        balance: null
      },
      currentxFrom: 1,
      numPagesFrom: 1,

      cpfTo: null,
      patientsTo: [],
      toSelected: null,
      searchTo: "",
      updatedTo: {
        name: null,
        cpf: null,
        balance: null
      },
      currentxTo: 1,
      numPagesTo: 1,

      invalidFields: {
        cpfTo: false,
        cpfFrom: false,
        cpfToValue: false,
        cpfFromValue: false,
        searchCpfTo: false,
        searchCpfFrom: false,
        value: false
      },
      windowWidth: 0,
    };
  },
  computed: {
    isPaginatedFrom () {
      return this.numPagesFrom > 1
    },
    isPaginatedTo () {
      return this.numPagesTo > 1
    },
    getMessageSourceAccount() {
      if (!this.fromSelected) {
        return "Selecione uma conta de origem"
      } else {
        const { name, cpf } = this.fromSelected
        
        return `${name} - ${this.maskCpf(cpf)}`
      }
    },
    getMessageTargetAccount() {
      if (!this.toSelected) {
        return "Selecione uma conta de destino"
      } else {
        const { name, cpf } = this.toSelected
        
        return `${name} - ${this.maskCpf(cpf)}`
      }
    },
  },
  async created () {
    this.bearer = await this.$session.get("bearer")

    window.addEventListener("resize", this.handleResize)
    this.handleResize()

    await this.getPatients()
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    getPatients(params = {}) {
      const type = params.type || null
      const page = params.page || 1
      const search = params.search || null

      this.axios.get(
        `${this.$store.state.filooServer}payment/list-patient-amount`,
        {
          params: { page: (page - 1), search: search },
          headers: { Authorization: this.bearer },
        }
      )
        .then(({ status, data }) => {
          if (status === 200) {
            if (!type || type === 'from') {
              this.patientsFrom = JSON.parse(JSON.stringify(data.content))
              this.numPagesFrom = Math.ceil(data.totalElements / 10)
            }
            if (!type || type === 'to') {
              this.patientsTo = JSON.parse(JSON.stringify(data.content))
              this.numPagesTo = Math.ceil(data.totalElements / 10)
            }
          }
        });
    },
    getPatientsFiltered(type, page) {
      if (type) {
        this.searchFrom = null
        this.searchTo = null

        const search = type === "from" ? this.cpfFrom : this.cpfTo

        this.getPatients({
          type,
          page,
          search: search.replace(/[^\d]+/g, ""),
        })
      }
    },
    handleFromSelected(select) {
      this.fromSelected = select
    },
    handleToSelected(select) {
      this.toSelected = select
    },
    validateFields(){
      const vm = this;
      let isInvalid = false;
      vm.invalidFields.cpfFrom= vm.testNullUndefinedEmpty(vm.fromSelected);
      vm.invalidFields.cpfTo= vm.testNullUndefinedEmpty(vm.toSelected) || (!vm.testNullUndefinedEmpty(vm.fromSelected)
       && vm.toSelected.cpf === vm.fromSelected.cpf);

      vm.isInvalidTransferAmount(vm.transferValue, vm.fromSelected);

      isInvalid = vm.invalidFields.cpfFrom || vm.invalidFields.cpfTo ||
        vm.invalidFields.value || vm.invalidFields.balance;
      if(!isInvalid) {
        vm.postTransfer();
      }
      else {
        vm.showNotifyWarning("Campo(s) mandatório(s) inválido(s) ou não preenchido(s). " +
          "Por favor, revise os campos destacados e tente novamente", 6000);
      }
    },
    postTransfer() {
      const vm = this;
      let transfer = {
        cpf_to: vm.toSelected.cpf,
        cpf_from: vm.fromSelected.cpf,
        value: vm.transferValue.replace(",", ".")
      };
      vm.axios
        .post(vm.$store.state.filooServer + "payment/transfer", transfer, {
          headers: { Authorization: this.bearer }
        })
        .then(function(response) {
          if (response.status === 200) {
            if (response.data === "saldo insuficiente") {
              vm.$swal({
                title: "Atenção!",
                text:
                  "Saldo insuficiente, para poder realizar essa operação",
                icon: "warning"
              });
            } else {
              vm.getPatients(true);
            }
          }
        }).catch(function(error) {
          if(error.message == "result returns more than one elements; nested exception"+
            "is javax.persistence.NonUniqueResultException: result returns more than one elements") {
            vm.$swal({
                title: "Atenção!",
                text:
                  "Erro ao realizar a transferência, mais de um usuário encontrado",
                icon: "warning"
              });
          }
        });
    },
    fillAndOpenPopUpSuccess() {
      const vm = this;
      for (let p in vm.patients) {
        if (vm.patients[p].id === vm.fromSelected.id) {
          vm.updatedFrom.name = vm.patients[p].name;
          vm.updatedFrom.cpf = vm.maskCpf(vm.patients[p].cpf);
          vm.updatedFrom.balance = vm.maskMoney(vm.patients[p].balance);
        }
        if (vm.patients[p].id === vm.toSelected.id) {
          vm.updatedTo.name = vm.patients[p].name;
          vm.updatedTo.cpf = vm.maskCpf(vm.patients[p].cpf);
          vm.updatedTo.balance = vm.maskMoney(vm.patients[p].balance);
        }
      }
      vm.popupTransferSuccess = true;
    },
    generateMessagevalue() {
      return this.invalidFields.balance
        ? "Saldo da conta de origem insuficiente"
        : "Insira um valor maior que zero"
    },
    isInvalidTransferAmount() {
      const vm = this;
      vm.invalidFields.balance = false;
      vm.invalidFields.value = vm.isInvalidValue(vm.transferValue);

      if(!vm.invalidFields.value) {
        vm.invalidFields.balance = vm.testNullUndefinedEmpty(vm.fromSelected)? false :
          parseFloat(vm.fromSelected.balance) < parseFloat(vm.transferValue);
      }
    },
    isInvalidValue() {
      const value = parseFloat(this.transferValue.replace(',','.')).toFixed(2)

      return !this.transferValue || value <= parseFloat(0.00)
    },
    showDangerValue() {
      return this.invalidFields.value || this.invalidFields.balance
    },
    closeSucess() {
      this.popupTransferSuccess = false
      this.transferValue = ""
      this.fromSelected = null
      this.toSelected = null
      this.cpfFrom = null
      this.cpfTo = null
      this.invalidFields.cpfTo = false
      this.invalidFields.cpfFrom = false
      this.invalidFields.value = false
      this.invalidFields.balance = false
    },
    canTransfer() {
      let vm=this;
      return vm.invalidFields.cpfTo || vm.showDangerValue() || vm.invalidFields.cpfFrom;
    },
    validateCpfTo() {
      const cpfFrom = this.cpfFrom && this.cpfFrom.cpf
      const cpfTo = this.toSelected && this.toSelected.cpf

      this.invalidFields.cpfTo = cpfFrom && cpfTo
        ? this.toSelected.cpf === this.fromSelected.cpf
        : !this.toSelected
    },
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    setSearchTimeout (val, type) {
      clearTimeout(this.searchTimeout)
      
      this.searchTimeout = setTimeout(() => {
        const cpf = val ? val.replace(/[^\d]+/g, "") : []

        this.getPatients({ type, search: cpf.length === 11 ? cpf : val })
      }, 500)
    }
  },
  watch: {
    searchFrom (newVal) {
      this.setSearchTimeout(newVal, "from")
    },
    searchTo (newVal) {
      this.setSearchTimeout(newVal, "to")
    },
    toSelected (newVal) {
      this.invalidFields.cpfTo = !newVal || !newVal.cpf

      if (!this.invalidFields.cpfTo) {
        const chkFromSelected = this.fromSelected && this.fromSelected.cpf

        this.invalidFields.cpfTo = !newVal.cpf && chkFromSelected
      }
    },
    fromSelected (newVal) {
      this.invalidFields.cpfFrom = !newVal || !newVal.cpf

      if (!this.invalidFields.cpfFrom) {
        this.validateCpfTo()

        if (this.transferValue) {
          this.isInvalidTransferAmount()
        }
      }
    },
    transferValue (newVal) {
      if (newVal) {
        this.isInvalidTransferAmount()
      }
    },
    cpfFrom (newVal) {
      if (newVal) {
        const cpf = newVal.replace(/[^\d]+/g, "")

        if (cpf.length === 11) {
          this.invalidFields.cpfFromValue = !this.validateCPF(cpf)
        }
      }
    },
    cpfTo (newVal) {
      if (newVal) {
        const cpf = newVal.replace(/[^\d]+/g, "")

        if (cpf.length === 11) {
          this.invalidFields.cpfToValue = !this.validateCPF(cpf)
        }
      }
    },
    currentxFrom(page) {
      this.getPatientsFiltered("from", page)
    },
    currentxTo(page) {
      this.getPatientsFiltered("to", page)
    },
  },
};
</script>

<style src="./TransferOfValues.css" />
